"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../utils/get-webshellclient-locale"));
var _makeQueryKey = _interopRequireDefault(require("../../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getPartnerCartReviewsQueryKey = function getPartnerCartReviewsQueryKey() {
  var country = (0, _getWebshellclientLocale["default"])().country;
  return (0, _makeQueryKey["default"])(['buy/partner_cart_reviews/v1', {
    country: country
  }]);
};
var _default = exports["default"] = getPartnerCartReviewsQueryKey;